import React, { createContext, useContext, useEffect, useState } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { lightTheme, darkTheme } from '../styles/colors';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
    // Initialize state with the value in local storage or default to 'light'
    const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

    useEffect(() => {
        // Update local storage when theme changes
        localStorage.setItem('theme', theme);
        // AMOLI CHANGE (if statement)
        if (localStorage.getItem('theme') === 'dark') {
            document.body.classList.add('dark-mode');
          } else {
            document.body.classList.remove('dark-mode');
          }

    }, [theme]);

    const toggleTheme = () => {
        setTheme(curr => curr === 'light' ? 'dark' : 'light');
    };

    // Correct the themeMode to match the theme
    const themeMode = theme === 'dark' ? darkTheme : lightTheme;

    return (
        <ThemeContext.Provider value={{ theme: 'light' }}>
            <StyledThemeProvider theme={lightTheme}>  
                {/* for now only light mode */}
                {children}
            </StyledThemeProvider>
        </ThemeContext.Provider>
    );
};
